import useSWR, { BareFetcher, SWRResponse } from 'swr';

import { KlassesIndexResponse as Response } from '@gmm/sdk-voodoo/classes/list';
import { KlassItem } from '@gmm/sdk/shared';
import { useCurrentTeacher } from '~/lib/hooks/useCurrentTeacher';
import { useSnackbar } from '~/lib/hooks/useSnackbar';
import { ReadOnlyOptions } from '~/lib/sdk';
import { sortBy } from '~/lib/sortHelper';
import { swrKeyFor, augmentSWR, voodooSdkFetcher } from '~/lib/swr';

const sortByName = sortBy<KlassItem>('name');

type ClassListResponse = SWRResponse<Response, unknown>;
export interface UseGetClassList extends ClassListResponse {
  /** Active classes only, sorted by name */
  activeClasses: ClassListResponse['data'];
}

export const useGetClassList = ({
  readOnly,
}: ReadOnlyOptions = {}): UseGetClassList => {
  const { enqueueGenericError } = useSnackbar();

  const { data: teacher } = useCurrentTeacher();

  const swrKey = swrKeyFor(() =>
    teacher ? ['classes.list', teacher.id] : null,
  );

  return useSWR(swrKey, {
    fetcher: voodooSdkFetcher as BareFetcher<Response>,
    onError: () => {
      enqueueGenericError();
    },
    revalidateIfStale: !readOnly,
    revalidateOnReconnect: !readOnly,
    use: [
      augmentSWR<Response>(
        'activeClasses',
        ({ data }) => data && sortByName(data.filter(({ active }) => active)),
      ),
    ],
  }) as UseGetClassList;
};
